import React from 'react'
import Content from '../../ui/Content'
import Grid from 'constructicon/grid'
import GridColumn from 'constructicon/grid-column'
import Image from '../../ui/Image'
import Section from '../../ui/Section'

const GridContent = ({
  alignment,
  backgroundImage,
  background,
  buttonBackground,
  buttonForeground,
  buttonStyle,
  copy,
  copyAlignment,
  foreground,
  gridColumns = 3,
  gridCopyAlignment,
  items = [],
  layout,
  size,
  spacing,
  subtitle,
  title,
  titleForeground
}) => {
  const calculateColumnSize = (gridColumns, factor) => 12 / Math.ceil(gridColumns * factor)

  return (
    <Section
      alignment={alignment}
      backgroundImage={backgroundImage}
      background={background}
      foreground={foreground}
      size={size}
      spacing={spacing}>
      <Content
        buttons={items}
        copy={copy}
        copyAlignment={copyAlignment}
        layout={layout}
        subtitle={subtitle}
        title={title}
        titleForeground={titleForeground}>

        <Grid
          justify='flex-start'
          spacing={1}>
          {items.map((item, i) => {
            const buttons = [{
              ...item.button,
              background: buttonBackground,
              block: buttonStyle === 'full width',
              foreground: buttonForeground
            }]

            return (
              <GridColumn
                key={i}
                sm={calculateColumnSize(gridColumns, 0.5)}
                md={calculateColumnSize(gridColumns, 1)}>
                <Image
                  image={item.image}
                  margin={{ b: 1 }}
                />
                <Content
                  align={gridCopyAlignment}
                  buttons={buttons.filter((button) => button.label)}
                  copy={item.copy}
                  subtitle={item.subtitle}
                  title={item.title}
                  titleForeground={titleForeground}
                />
              </GridColumn>
            )
          })}
        </Grid>

      </Content>
    </Section>
  )
}

export default GridContent



// WEBPACK FOOTER //
// ./components/slices/GridContent/index.js